#import "../fragments/notify-message-fragment.graphql"

query GetNotifyMessages {
    loggedInUser {
        id
        notifies {
            ...NotifyMessageFragment
        }
    }
}
